import React, { memo } from "react"
import { Helmet } from "react-helmet"

type MetaTagsProps = {
  title: string
  description?: string
  ogDescription?: string
  ogTitle?: string
  ogImage?: string
  absoluteOgImageUrl?: boolean
}

export const MetaTags: React.FC<MetaTagsProps> = memo(
  ({ title, description, ogTitle, ogDescription, ogImage, absoluteOgImageUrl, children }) => (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={absoluteOgImageUrl ? ogImage : `https://withcove.com${ogImage}`} />
      {/* Add additional tags as children */}
      {children}
    </Helmet>
  )
)
